import cx from 'classnames';
import { CatTextLink } from '@blocks-react/components/TextLink';
import { FC, PropsWithChildren } from 'react';
import { LinkWithIconProps } from './types';

export const LinkWithIcon: FC<PropsWithChildren<LinkWithIconProps>> = ({
  icon,
  children,
  href,
  target,
  linkClassName,
  linkTextClassName,
  ariaLabel,
}) => {
  return (
    <CatTextLink
      href={href}
      target={target}
      className={cx('d-flex align-items-center', linkClassName)}
      aria-label={ariaLabel}
    >
      <div className="d-flex align-items-center me-2">{icon}</div>
      <span className={cx(linkTextClassName, 'restart-global')}>
        {children}
      </span>
    </CatTextLink>
  );
};
